module.exports = __webpack_public_path__ + "static/content-bg.839d6019.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/serviceProvider/content-bg.png
// module id = 1038
// module chunks = 2